import { API_URL } from '../config/constants';

export const getAccessToken = async (sessionData) => {
    try {
        const request = new Request(API_URL + "/v2/getAccessToken", {
            method: 'POST',
            body: JSON.stringify({
                username: sessionData.userName,
                password: sessionData.passwd,
            }),
            headers: new Headers({
                'Content-Type': 'application/json'
            })
        });
        const response = await fetch(request);
        const json = await response.json();
        if (response.status !== 200 && response.code !== 200) {
            throw response;
        }
        return json.result.data.token;
    } catch (err) {
        if (!err.code && !err.status) err.status = 500;
        throw err;
    }
}



// WEBPACK FOOTER //
// ./src/controllers/reportsBi.js